import SingleChoice from '@components/quiz/questions/single-choice'
import TextInput from '@components/quiz/questions/text-input'
import NumberInput from '@components/quiz/questions/number-input'
import MultipleChoice from '@components/quiz/questions/multiple-choice'
import HeightWeight from '@components/quiz/questions/height-weight'
import Content from '@components/quiz/questions/content'
import Birthday from '@components/quiz/questions/birthday'
import Select from '@components/quiz/questions/select'

import {
  QuizStepType,
  StepComponentProps,
  QuizSteps,
  MultipleChoiceQuizStep,
} from '@types'
import Slider from './slider'

type ComponentType = React.FC<StepComponentProps<any, any>>

export const components: Record<QuizStepType, ComponentType> = {
  [QuizStepType.BIRTHDAY]: Birthday,
  [QuizStepType.CONTENT]: Content,
  [QuizStepType.HEIGHT_WEIGHT]: HeightWeight,
  [QuizStepType.MULTIPLE_CHOICE]: MultipleChoice,
  [QuizStepType.NUMBER]: NumberInput,
  [QuizStepType.SINGLE_CHOICE]: SingleChoice,
  [QuizStepType.SELECT]: Select,
  [QuizStepType.TEXT]: TextInput,
  [QuizStepType.SLIDER]: Slider,
}

export const getQuestionDefaultValue = (step: QuizSteps): any => {
  switch (step.type) {
    case QuizStepType.MULTIPLE_CHOICE:
      const multipleChoiceStep = step as MultipleChoiceQuizStep
      if (multipleChoiceStep.negation) {
        return multipleChoiceStep.options
          .map(o => o.value)
          .filter(value => value === 'none')
      } else {
        return []
      }
    case QuizStepType.HEIGHT_WEIGHT:
      return {
        height: null,
        weight: null,
      }
    case QuizStepType.SINGLE_CHOICE:
    case QuizStepType.SELECT:
      return ''
    case QuizStepType.SLIDER:
      return 10
    default:
      return null
  }
}
